import React, { useCallback, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import { useDispatch } from 'react-redux';

import { Filter } from '../../../Enum/Filters';
import InterestUri from '../../../Enum/InterestUri';

import { filterSubmitted } from '../../../Store/Filter/action';
import useCanFilterBeSubmitted from '../../../Hook/Interest/UseCanFilterBeSubmitted';
import useIsFilterLoading from '../../../Hook/Interest/UseIsFilterLoading';
import { filterValuesChanged } from '../../../Store/Pdf/action';
import { useGetFilterSelectionValues } from '../../../Hook/Interest/UseGetFilterValue';

interface Props {
    filterProperties: Filter[];
    allowEmptyArray?: boolean;
    section?: InterestUri;
}

const SubmitFilter: React.FC<Props> = ({ filterProperties, allowEmptyArray, section }: Props) => {
    const dispatch = useDispatch();
    const enabled = useCanFilterBeSubmitted(filterProperties, allowEmptyArray ?? false);
    const loading = useIsFilterLoading();
    const { labels, properties } = useGetFilterSelectionValues(section);

    const dispatchFilterValues = useCallback(() => {
        if (labels.length > 0) {
            dispatch(filterValuesChanged(labels));
        }

        if (properties.length > 0) {
            dispatch(filterValuesChanged(properties));
        }
    }, [dispatch, labels, properties]);

    useEffect(() => {
        dispatchFilterValues();
    }, []);

    const handleClick = useCallback((): void => {
        dispatchFilterValues();
        dispatch(filterSubmitted());
    }, [dispatch, labels, properties]);

    return (
        <>
            <Button disabled={!enabled || loading} block onClick={handleClick}>
                TOEPASSEN
            </Button>
        </>
    );
};

export default SubmitFilter;
